import './Styles/App.scss';
import Quiz from './Components/Quiz';

export default function App() {
  return <Quiz />;
}